var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',{attrs:{"setup":{
    'func': _vm.triggerInputSetupFn,
    'args': {
      model: _vm.model,
      'key': 'formButtonAction',
      'prefix': 'trigger_action_',
      disabled: _vm.disabled,
    }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }